<app-add-modo
  (mostrarBotones)="ocultarBotones($event)"
  [modoEntradas]="modoEntradas"></app-add-modo>
<mat-card-content class="catalog-list" *ngFor="let modo of modoEntradas">
  <div *ngIf="admonCatModoStatus$ | async as modoEntradaStatus">
    <mat-card class="catalog-card">
      <div
        class="catalog-card-view"
        *ngIf="
          !modoEntradaStatus.mostrarEditar ||
          (modoEntradaStatus.mostrarEditar && registroSeleccionado !== modo)
        ">
        <p class="catalog-title" style="padding: 1rem">
          {{ modo?.descripcion }}
        </p>
        <mat-card-actions
          align="end"
          class="nuevo-catalogo-actions"
          *ngIf="
            !modoEntradaStatus.mostrarEditar && !modoEntradaStatus.mostrarNuevo
          ">
          <button
            class="uppercase-button"
            mat-button
            (click)="editarRegistro(modo)">
            Editar
          </button>
          <button
            class="uppercase-button"
            mat-button
            (click)="eliminarEmpresa(modo)">
            Borrar
          </button>
        </mat-card-actions>
      </div>
    </mat-card>
  </div>
  <div *ngIf="admonCatModoStatus$ | async as modoEntradaStatus">
    <mat-card
      class="catalog-card"
      *ngIf="modoEntradaStatus.mostrarEditar && registroSeleccionado === modo">
      <div class="catalog-card-header">
        <p class="catalog-title">
          {{ modo?.descripcion }}
        </p>
      </div>
      <div class="catalog-card-edit">
        <form
          [formGroup]="editarForm"
          class="nuevo-catalogo-form nuevo-catalogo-form-input !flex">
          <mat-form-field class="nuevo-catalogo-field !w-1/2">
            <mat-label>Descripción</mat-label>
            <input
              formControlName="descripcion"
              name="descripcion"
              class="nuevo-catalogo-input"
              type="text"
              maxlength="50"
              matInput
              [value]="modo?.descripcion"
              placeholder=""
              (input)="
                existeRegistro(editarForm.get('descripcion'), modo?.descripcion)
              " />
            <mat-hint align="end"
              >{{ editarForm.get("descripcion")?.value.length }} / 50</mat-hint
            >

            @if (editarForm.get('descripcion')?.hasError('campoRequerido') &&
            editarForm.get('descripcion')?.touched && !editarForm
            .get('descripcion') ?.hasError('descripcionDuplicad@')) {
            <mat-error>Campo obligatorio</mat-error>
            } @else if ( editarForm.get('descripcion')?.touched &&
            editarForm.get('descripcion')?.hasError('descripcionCatalogo')) {
            <mat-error> Sólo se permiten letras y espacios. </mat-error>
            } @else if ( editarForm.get('descripcion')?.touched && editarForm
            .get('descripcion') ?.hasError('descripcionDuplicad@')) {
            <mat-error> La descripción ya se encuentra registrada. </mat-error>
            }
          </mat-form-field>
        </form>
        <mat-card-actions align="end" class="nuevo-catalogo-actions">
          <button
            class="uppercase-button"
            mat-button
            (click)="cancelarEdicion()">
            Cancelar
          </button>
          <button
            class="uppercase-button"
            mat-button
            [disabled]="editarForm.invalid"
            (click)="guardarCambios(modo)">
            Guardar
          </button>
        </mat-card-actions>
      </div>
    </mat-card>
  </div>
</mat-card-content>
<br />
